/* eslint-disable */
/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-17 18:17:33
 * @LastEditors: susj
 * @LastEditTime: 2020-10-26 14:22:44
 */
import Element from './element';
import PptBackground from '../../plugins/ppt-background'

class Page {
  constructor(page = {}) {
    this.uuid = page.uuid || +new Date();
    this.pptId = page.pptId || '';
    this.title = page.title || '';
    this.slideType  = page.slideType  || 0,
    this.elements = page.elements || [new Element(PptBackground)]
  }

  clone() {
    const elements = this.elements.map(element => new Element(element));
    return new Page({ title: this.title, elements });
  }
}

export default Page;
